import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { aktiveMesspunkt, betriebsereignisState, messstellenListe, sort, sortOrder, sortProp} from './betriebsereignisseTypes';
import { AppDispatch, RootState } from '../../app/store';
import { getWithAuth, postWithAuth } from '../../utils/api';
import { logError } from '../../utils/utils';
import { betriebsereignisKommunikation, betriebsereignisDatenvollsteandigkeit, betriebsereignisListe, betriebsstatus } from '../../utils/apiTypes';
import { errorHandler } from '../../utils/errorHandling';


const initialState: betriebsereignisState = {
    betriebsstatusListe: [],
    maxKommunication: -1,
    numberOfDevicesKommunikation: -1,
    maxDatenvollsteandigkeit: -1,
    numberOfDevicesDatenvollstaendigkeit: -1,
    aktiveMesspunkt: [],
    datenvollsteandigkeitListe: [],
    kommunikationListe: [],
    messstellenKommunikationListe: [],
    messstellenDatenvollstaendigkeitListe: [],
    betriebsereignisListe: [],
    BetriebsereignisseLoading: false,
    datenvollsteandigkeitLoading: false,
    kommunikationLoading: false,
    betriebsereignisLoading: false,
    selectedMessstelle: "",
    sort: { sortProp: sortProp.kommunikation, sortOrder: null },
}

const betriebsereignisseSlice = createSlice({
    name: "betriebsereignisse",
    initialState,
    reducers: {
        setBetriebsstatusListe: (state, action: PayloadAction<Array<betriebsstatus>>) => {
            state.betriebsstatusListe = action.payload;
        },
        setMaxKommunication: (state, action: PayloadAction<number>) => {
            state.maxKommunication = action.payload;
        },
        setNumberOfDevicesKommunikation: (state, action: PayloadAction<number>) => {
            state.numberOfDevicesKommunikation = action.payload;
        },
        setNumberOfDevicesDatenvollstaendigkeit: (state, action: PayloadAction<number>) => {
            state.numberOfDevicesDatenvollstaendigkeit = action.payload;
        },
        setMaxDatenvollsteandigkeit: (state, action: PayloadAction<number>) => {
            state.maxDatenvollsteandigkeit = action.payload;
        },
        setAktiveMesspunkt: (state, action: PayloadAction<Array<aktiveMesspunkt>>) => {
            state.aktiveMesspunkt = action.payload;
        },
        setDatenvollsteandigkeitListe: (state, action: PayloadAction<Array<betriebsereignisDatenvollsteandigkeit>>) => {
            state.datenvollsteandigkeitListe = action.payload;
        },

        setKommunikationListe: (state, action: PayloadAction<Array<betriebsereignisKommunikation>>) => {
            state.kommunikationListe = action.payload;
        },

        setMessstellenKommunikationListe: (state, action: PayloadAction<Array<betriebsereignisKommunikation>>) => {
            state.messstellenKommunikationListe = action.payload;
        },
        setMessstellenDatenvollstaendigkeitListe: (state, action: PayloadAction<Array<betriebsereignisDatenvollsteandigkeit>>) => {
            state.messstellenDatenvollstaendigkeitListe = action.payload;
        },
        setLoadingBetriebsereignisse: (state, action: PayloadAction<boolean>) => {
            state.BetriebsereignisseLoading = action.payload;
        },
        setLoadingDatenvollsteandigkeit: (state, action: PayloadAction<boolean>) => {
            state.datenvollsteandigkeitLoading = action.payload;
        },
        setLoadingKommunikation: (state, action: PayloadAction<boolean>) => {
            state.kommunikationLoading = action.payload;
        },
        setLoadingBetriebsereignis: (state, action: PayloadAction<boolean>) => {
            state.betriebsereignisLoading = action.payload;
        },
        setSelectedMessstelle: (state, action: PayloadAction<string>) => {
            state.selectedMessstelle = action.payload;
        },
        setSort: (state, action: PayloadAction<sort>) => {
            if (action.payload.sortOrder == null) {
                state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => a.umspannwerk.localeCompare(b.umspannwerk) || a.messstelle.localeCompare(b.messstelle));
            } else if (action.payload.sortProp == sortProp.datenvollstaendigkeit) {
                if (action.payload.sortOrder == sortOrder.errorFirst) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => b.datenvollstaendigkeit - a.datenvollstaendigkeit);
                } else if (action.payload.sortOrder == sortOrder.errorLast) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => a.datenvollstaendigkeit - b.datenvollstaendigkeit);
                }
            } else if (action.payload.sortProp == sortProp.kommunikation) {
                if (action.payload.sortOrder == sortOrder.errorFirst) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => b.kommunikation - a.kommunikation);
                } else if (action.payload.sortOrder == sortOrder.errorLast) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => a.kommunikation - b.kommunikation);
                }
            }
            state.sort = action.payload;
        },
        updateSort: (state) => {
            if (state.sort.sortOrder == null) {
                state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => a.umspannwerk.localeCompare(b.umspannwerk) || a.messstelle.localeCompare(b.messstelle));
            } else if (state.sort.sortProp == sortProp.datenvollstaendigkeit) {
                if (state.sort.sortOrder == sortOrder.errorFirst) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => b.datenvollstaendigkeit - a.datenvollstaendigkeit);
                } else if (state.sort.sortOrder == sortOrder.errorLast) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => a.datenvollstaendigkeit - b.datenvollstaendigkeit);
                }
            } else if (state.sort.sortProp == sortProp.kommunikation) {
                if (state.sort.sortOrder == sortOrder.errorFirst) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => b.kommunikation - a.kommunikation);
                } else if (state.sort.sortOrder == sortOrder.errorLast) {
                    state.betriebsstatusListe = state.betriebsstatusListe.sort((a, b) => a.kommunikation - b.kommunikation);
                }
            }
        },
    }
});

export const {
    setBetriebsstatusListe,
    setMaxKommunication,
    setNumberOfDevicesKommunikation,
    setMaxDatenvollsteandigkeit,
    setNumberOfDevicesDatenvollstaendigkeit,
    setAktiveMesspunkt,
    setDatenvollsteandigkeitListe,
    setKommunikationListe,
    setLoadingBetriebsereignisse,
    setLoadingDatenvollsteandigkeit,
    setLoadingKommunikation,
    setMessstellenKommunikationListe,
    setMessstellenDatenvollstaendigkeitListe,
    setSelectedMessstelle,
    setSort,
    updateSort,
} = betriebsereignisseSlice.actions

export const selectAktiveMesspunkte = (state: RootState): Array<aktiveMesspunkt> => state.betriebsereignisse.aktiveMesspunkt;
export const selectMaxKommunication = (state: RootState): number => state.betriebsereignisse.maxKommunication;
export const selectNumberOfDevicesKommunikation = (state: RootState): number => state.betriebsereignisse.numberOfDevicesKommunikation;
export const selectMaxDatenvollsteandigkeit = (state: RootState): number => state.betriebsereignisse.maxDatenvollsteandigkeit;
export const selectNumberOfDevicesDatenvollstaendigkeit = (state: RootState): number => state.betriebsereignisse.numberOfDevicesDatenvollstaendigkeit;
export const selectDatenvollsteandigkeitListe = (state: RootState): Array<betriebsereignisDatenvollsteandigkeit> => state.betriebsereignisse.datenvollsteandigkeitListe;
export const selectKommunikationListe = (state: RootState): Array<betriebsereignisKommunikation> => state.betriebsereignisse.kommunikationListe;
export const selectMessstellenListe = (state: RootState): Array<messstellenListe> =>
    state.betriebsereignisse.messstellenKommunikationListe.map(x => ({ messstelle: x.messstelle, kommunikationStatus: x.status, datenStatus: state.betriebsereignisse.messstellenDatenvollstaendigkeitListe.filter(dv => dv.messstelle == x.messstelle)[0]?.status ?? 2 }));     
export const selectBetriebsereignisListe = (state: RootState): Array<betriebsereignisListe> =>
    [...state.betriebsereignisse.kommunikationListe.map(x => ({ ...x, typ: 0 })), ...state.betriebsereignisse.datenvollsteandigkeitListe.map(x => ({ ...x, typ: 1 }))];
export const selectLoadingDatenvollsteandigkeit = (state: RootState): boolean => state.betriebsereignisse.datenvollsteandigkeitLoading;
export const selectLoadingKommunikation = (state: RootState): boolean => state.betriebsereignisse.kommunikationLoading;
export const selectBetriebesstatusListe = (state: RootState): Array<betriebsstatus> => state.betriebsereignisse.betriebsstatusListe;
export const selectSelectedMessstelle = (state: RootState): string => state.betriebsereignisse.selectedMessstelle;
export const selectSort = (state: RootState): sort => state.betriebsereignisse.sort;

export const getBetriebsereignisse = () => (dispatch: AppDispatch): void => {
    dispatch(setLoadingDatenvollsteandigkeit(true));
    getWithAuth("DATENVOLLSTEANDIGKEIT", {})
        .then((response: betriebsereignisDatenvollsteandigkeit[]) => {
                dispatch(setDatenvollsteandigkeitListe(response));
        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setLoadingDatenvollsteandigkeit(false)));

    dispatch(setLoadingKommunikation(true));
    getWithAuth("KOMMUNIKATION", {})
        .then((response: betriebsereignisKommunikation[]) => {
                dispatch(setKommunikationListe(response));
        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setLoadingKommunikation(false)));
}

export const getBetriebsstatus = () => (dispatch: AppDispatch): void => {
    dispatch(setLoadingKommunikation(true));
    dispatch(setLoadingDatenvollsteandigkeit(true));
    getWithAuth("BETRIEBSSTATUS", {}).then((response: Array<betriebsstatus>) => {
        dispatch(setBetriebsstatusListe(response));
        dispatch(updateSort());

        const response_maxKommunicationStatus = response.reduce((response, x) => response.kommunikation > x.kommunikation ? response : x).kommunikation;
        dispatch(setMaxKommunication(response_maxKommunicationStatus));
        dispatch(setNumberOfDevicesKommunikation(response.filter(x => x.kommunikation == response_maxKommunicationStatus).length));

        const response_maxDatenStatus = response.reduce((response, x) => response.datenvollstaendigkeit > x.datenvollstaendigkeit ? response : x).datenvollstaendigkeit;
        dispatch(setMaxDatenvollsteandigkeit(response_maxDatenStatus));
        dispatch(setNumberOfDevicesDatenvollstaendigkeit(response.filter(x => x.datenvollstaendigkeit == response_maxDatenStatus).length));
    }
        ).catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() =>{ dispatch(setLoadingDatenvollsteandigkeit(false)); setLoadingKommunikation(false)});
}

export const getAktiveMesspunkte = () => (dispatch: AppDispatch): void => {
    postWithAuth("POSTAKTIVEMESSPUNKTE", {}, "name,umspannwerk,schaltfeld,messgeraetSeriennummer,messgeraetIP,routerIP,routerSeriennummer").then((messpunkte) => {        
        dispatch(setAktiveMesspunkt(messpunkte));
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    });
}

export default betriebsereignisseSlice.reducer